import { render, staticRenderFns } from "./RamoSaludComponent.vue?vue&type=template&id=66b8b785"
import script from "./RamoSaludComponent.vue?vue&type=script&lang=js"
export * from "./RamoSaludComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports